import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress, Typography, Stack } from '@mui/material';

const LoadingInProgress = () => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" marginTop={3}>
      <CircularProgress />
      <Typography variant="body1" color="textSecondary">
        {t('loadingInProgress')}
      </Typography>
    </Stack>
  );
};

export default LoadingInProgress;
